// extracted by mini-css-extract-plugin
export default {"site_footer":"styles_site_footer__6eFOJ","site_footer__copyright":"styles_site_footer__copyright__A9XGB"};